import React, { useState } from "react";

import "./interestGroup.scss";
import bannerGroups from "../../assets/imgs/banner-grupos.png";
import { useGenericSection } from "../../services/genericSection.service";
import { useEffect } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import ContentBlocker from "../../components/contentBlocker/contentBlocker";

export function InterestGroup() {
  const [data, setData] = useState([]);
  const [disabledHasMore, setDisabledHasMore] = useState(false);

  const loadMore = () => {
    if (data.length > 0) {
      const lastitem = data.slice(-1).pop();
      loadData(lastitem.genericSectionItemId);
    }
  };

  const loadData = (id) => {
    useGenericSection.getGenericItemByCompanyAndSection(2, id, 9).then(items => {
      if (items.length > 0) {
        const newItems = [...data, ...items];
        setData(newItems);
      } else {
        setDisabledHasMore(true);
      }
    });
  }

  useEffect(() => {
    loadData();
  }, []);

  return (
      <section className="container-page pt-4">
      <h2>Grupos de Interés</h2>
      <div className="drawer__bg__sections">
        <img
          src={bannerGroups}
          alt="Grupos donde nuestra comunidad es protagonista"
        />
      </div>

      <InfiniteScroll
        dataLength={data.length}
        next={() => loadMore()}
        hasMore={!disabledHasMore}
        loader={<h4>No tienes Grupos de Interés previos</h4>}
        scrollableTarget="scrollableDiv"
        style={{overflow: 'unset !important'}}
      >
          <ContentBlocker
              content={data}
              typeContent={"interestGroup"}
              limitArray={4}
              title={"¿Quieres ver más sugerencias?"}
          />
      </InfiniteScroll>
    </section>
  );
}
